import React from 'react';
import { Toast } from 'react-bootstrap';

const TcpFallbackToast = ({ show, onClose }) => {
  return (
    <Toast
      show={show}
      onClose={onClose}
      delay={30000}
      autohide
      style={{
        position: 'fixed',
        left: 20,
        right: 'auto',
        bottom: 20,
        zIndex: 9999,
        width: 'calc(100vw - 40px)',
        maxWidth: 360,
        background: 'rgba(46, 32, 12, 0.92)',
        color: '#fff',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        border: '1px solid rgba(255, 180, 70, 0.45)',
        borderRadius: 8,
        boxShadow: '0 4px 14px rgba(0, 0, 0, 0.35)',
        fontSize: 12,
      }}
    >
      <Toast.Body style={{ display: 'flex', alignItems: 'flex-start', gap: 8, padding: '12px 14px' }}>
        <div style={{ flex: 1, minWidth: 0, lineHeight: 1.45 }}>
          <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 4, color: '#ffb84d' }}>
            UDP ports blocked
          </div>
          <div style={{ color: 'rgba(255,255,255,0.9)' }}>
            Your network is blocking UDP, so the stream is being relayed over TCP — this reduces streaming performance. Ask your IT administrator to allow outbound <strong>UDP port 3478</strong> for the best experience.
          </div>
        </div>
        <button
          type="button"
          aria-label="Dismiss"
          onClick={onClose}
          style={{
            background: 'transparent',
            border: 'none',
            color: 'rgba(255,255,255,0.7)',
            cursor: 'pointer',
            fontSize: 18,
            lineHeight: 1,
            padding: '4px 6px',
            margin: '-4px -6px -4px 0',
            flexShrink: 0,
          }}
        >
          ×
        </button>
      </Toast.Body>
    </Toast>
  );
};

export default TcpFallbackToast;
